import http from '@/utils/http';
const base_path = '/v2/tool/targeting';

/**
 * 获取定向包列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getTargetingListApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};

/**
 * 同步定向包列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const pullTargetingListApi = (params) => {
  return http.get({
    url: `${base_path}/pull`,
    params,
  });
};

/**
 * 创建定向包接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const addTargetingDataApi = (data) => {
  return http.post({
    url: base_path,
    data,
  });
};

/**
 * 删除定向包接口
 * @param {number|string} targeting_id 定向包 ID
 * @param {Object} params Query 参数
 * @returns {Promise<Object>}
 */
export const deleteTargetingDataApi = (targeting_id, params) => {
  return http.delete({
    url: `${base_path}/${targeting_id}`,
    params,
  });
};

/**
 * 更新定向包接口
 * @param {number|string} targeting_id 定向包 ID
 * @param {Object} data body数据
 * @returns {Promise<Object>}
 */
export const editTargetingDataApi = (targeting_id, data) => {
  return http.put({
    url: `${base_path}/${targeting_id}`,
    data,
  });
};

/**
 * 获取定向包详情数据接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getTargetingDataApi = (id, params) => {
  return http.get({
    url: `${base_path}/${id}`,
    params,
  });
};

/**
 * 获取定向字典接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getTargetingDictionaryApi = (params) => {
  return http.get({
    url: `${base_path}/dictionary`,
    params,
  });
};
